import * as React from 'react';
import { graphql } from 'gatsby';
import { GatsbySeo } from 'gatsby-plugin-next-seo';
import BlockContent from '@sanity/block-content-to-react';
import PropTypes from 'prop-types';

import { useTheme } from '../hooks';
import { Layout } from '../components';

export default function GolfTipsTemplate({ data: { sanityPost } }) {
  useTheme('');
  return (
    <Layout>
      <GatsbySeo title={sanityPost.title} description={sanityPost.title} />
      <article className="w-full px-6 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="w-full max-w-2xl mx-auto">
          <div className="text-center">
            <h1 className="h2">{sanityPost.title}</h1>
            <p className="mt-2 text-gray-500">
              Published on <time>{sanityPost.publishedAt}</time> by{' '}
              {sanityPost.author.name}
            </p>
          </div>
          <div className="mt-12 text-base leading-6 prose text-gray-500">
            <BlockContent
              blocks={sanityPost._rawBody}
              projectId={process.env.GATSBY_SANITY_PROJECT_ID}
              dataset={process.env.GATSBY_SANITY_DATASET}
            />
          </div>
        </div>
      </article>
    </Layout>
  );
}

GolfTipsTemplate.propTypes = {
  data: PropTypes.object.isRequired,
};

export const query = graphql`
  query GolfTipsTemplateQuery($id: String!) {
    sanityPost(id: { eq: $id }) {
      id
      _rawBody
      slug {
        current
      }
      title
      categories {
        title
        id
      }
      author {
        name
      }
      mainImage {
        asset {
          fluid(maxWidth: 1920) {
            ...GatsbySanityImageFluid
          }
        }
      }
      publishedAt(formatString: "DD MMMM, YYYY")
    }
  }
`;
